// export var Globals = {};

export var Status = {
  CONNECTED: 1,
  DISCONNECTED: 2,
};

export var ErrorTypes = {
  GENERAL_ERROR: "100",
  INVALID_MESSAGE: "101",
  INVALID_SERVICE: "102",
  CONCURRENT_CONNECTION: "103",
  ALREADY_LOGGED_IN: "104",
  NOT_LOGGED_IN: "105",
  SESSION_CLOSED: "105",
  INVALID_TRANSFER: "106",
  INVALID_BET_AMOUNT: "107",
  INSUFFICIENT_FUNDS: "108",
  INVALID_BET: "109",
  INVALID_SESSION: "110",
  STAGE_TIMEOUT: "112",
  JACKPOT_NOT_ACTIVE: "114",
  MAX_BET_LIMIT: "115",
  // CLIENT_SEED_ERROR: '8',
  // INVALID_BET_AMOUNT: '4',
  // PF_NOT_SET: '7',
  // CLIENT_SEED_OK: '9',
  // SYSTEM_ERROR: '10',
  // INVALID_ACTION: '11',
  // SEAT_TAKEN: '12',
  // NOT_FOUND: '13',
  // GAME_NOT_ACTIVE: '14',
  // JACKPOT_NOT_ACTIVE: '15',
  // FAUCET_ERROR: '16',
  // INSUFFICIENT_RAISE_FUNDS: '17',
};

export const ErrorTexts = {
  CONCURRENT_CONNECTION: "message.error.concurrentConnect",
  INVALID_SESSION: "message.error.smtWrong",
  INSUFFICIENT_FUNDS: "message.error.insufficientFunds",
  INVALID_BET_AMOUNT: "message.error.invalidBetAmount",
  MONEY_TRANSFER_ERROR: "message.error.smtWrong",
  INVALID_BET: "message.error.invalidBet",
  PF_NOT_SET: "message.error.pfNotSet",
  CLIENT_SEED_ERROR: "message.error.clientSeedError",
  CLIENT_SEED_OK: "9",
  SYSTEM_ERROR: "message.error.smtWrong",
  INVALID_ACTION: "message.error.invalidAction",
  SEAT_TAKEN: "12",
  NOT_FOUND: "message.error.notFound",
  GAME_NOT_ACTIVE: "message.error.gameNotActive",
  JACKPOT_NOT_ACTIVE: "15",
  CONNECTION_LOST: "message.error.connectionLost",
  FAUCET_ERROR: "message.error.faucetError",
};

export const Notifications = {
  minStake: "message.message.minStake", // {minimum_stake} {currency}
  maxStake: "message.maxStake", // {maximum_stake} {currency}
  notEnoughBalance: "message.notEnoughBalance",
  invalidAction: "message.invalidAction",
  invalidBet: "message.invalidBet",
  copied: "message.copied",
  notFound: "message.notFound",
  onlyYourBet: "message.onlyYourBet",
  cantChangeSeed: "message.cantChangeSeed",
  cantSelectBeforeBet: "message.cantSelectBeforeBet",
  invalidSeed: "message.invalidSeed",
  reachedMaxStake: "message.reachedMaxStake", // {maximum_bet} {currency}
  stoppedOnLoss: "message.stoppedOnLoss ", // {autorollLogic_ggr} {currency}
  stoppedOnWin: "message.stoppedOnWin ", // {autorollLogic_ggr} {currency}
  onSelectedNumberOfBets: "message.onSelectedNumberOfBets",
  moneyTransferError: "message.moneyTransferError",
  insufficientRaiseFunds: "message.insufficientRaiseFunds",
  stageTimeout: "message.stageTimeout",
  transferError: "message.transferError",
  maxbetlimit: "message.maxBetLimit",
};
